import { Box, Typography } from "@mui/material";
import React from "react";
import { Page_Padding } from "../../shared/constants";
import { AiEdgeImages } from "../../assets/img/aiedge/AiEdgeImages";
import Heading from "../../shared/utils/Heading";
import CustomDivider from "../../shared/utils/CustomDivider";
import useResponsive from "../../shared/utils/Responsive";
import { getImageUrl } from "../../shared/utils/getImageUrl";

const HeroSection = ({ heroData, bottomData }) => {
  const isSmallScreen = useResponsive("md");

  // Reusable typography style
  const Highlight = ({ children }) => (
    <Typography component="span" sx={{ color: "#DC143C", fontWeight: 700 }}>
      {children}
    </Typography>
  );

  const content = (
    <Box
      sx={{
        width: isSmallScreen ? "100%" : "40%",
        textAlign: isSmallScreen ? "center" : "left",
      }}
      pr={isSmallScreen ? 0 : Page_Padding}
      pt={isSmallScreen ? 0 : "13%"}
    >
      <Heading
        SubHeading={heroData?.heading}
        Heading={heroData?.subheading}
        center={isSmallScreen}
      />

      <Typography variant="subtitle1" fontWeight={300}   dangerouslySetInnerHTML={{ __html: heroData?.description }} />
        {/* <Highlight>LATAA</Highlight> is our proprietary AI-powered learning
        assistant designed to give every child a personalized, complete, and
        concept-based academic journey.
      </Typography> */}

      {/* <CustomDivider size="1rem" />

      <Typography variant="subtitle1" fontWeight={300}>
        Built and trained by our expert SMEs, <Highlight>LATAA</Highlight>{" "}
        understands each student individually—how they learn, what they know,
        where they struggle—and automatically creates content tailored to their
        unique learning level.
      </Typography> */}
    </Box>
  );

  return (
    <Box>
      {/* HERO IMAGE SECTION */}
      <Box
        sx={{
          width: "100%",
          aspectRatio: { xs: "16/10", sm: "16/10", md: "16/8" },
          // backgroundImage: `url(${AiEdgeImages.HeroImage})`,
             backgroundImage: `url(${getImageUrl(heroData?.imageUrl)})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "left",
          backgroundSize: { xs: "100% auto", md: "80% auto" },
          display: "flex",
          justifyContent: isSmallScreen ? "center" : "flex-end",
          alignItems: "center",
          px: isSmallScreen ? Page_Padding : 0,
        }}
      >
        {!isSmallScreen && content}
      </Box>

      {/* CONTENT ON SMALL SCREENS */}
      <Box px={Page_Padding}>
        <CustomDivider size={"1rem"} />

        {isSmallScreen && content}

        {isSmallScreen && <CustomDivider size={"1rem"} />}

        <Typography
          variant="h6"
          fontWeight={600}
          textAlign="center"
          sx={{
            width: { xs: "100%", sm: "100%", md: "80%" },
            mx: "auto",
          }}
           dangerouslySetInnerHTML={{ __html: bottomData?.description }} 
        />
        {/* <Highlight>LATAA</Highlight> combines the best of NCERT-aligned
          academics, grade-wise concept mastery (ELYF), and skill-based
          experiential learning from our camps to ensure children develop strong
          foundations with real understanding, not rote learning.
        </Typography> */}
      </Box>
    </Box>
  );
};

export default HeroSection;
